// resources/js/admin/services/mediaService.ts

import axios from "axios";
import { Media, MediaFormData, MediaUploadData } from "../types/features/Media";
import { MAIN_API_URL } from "../config/api";
import { PaginatedResponse } from "../types/core/PaginatedResponse";

export const mediaService = {
// 🔒 PROTÉGÉ - Token requis (lecture admin)
async getAll(
  token: string,
  siteSlug: string,
  page: number = 1,
  perPage: number = 20,
  type?: string,
  search?: string
): Promise<PaginatedResponse<Media>> {
  try {
    const response = await axios.get(`${MAIN_API_URL}/media/site/${siteSlug}`, {
      params: { page, per_page: perPage, type, search },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des médias", error);
    throw error;
  }
},
  // 🔓 PUBLIC - Pas de token nécessaire (lecture)
  async getById(id: string): Promise<Media> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/media/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement du média", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis (upload)
async upload(token: string, data: MediaUploadData): Promise<Media> {
    const formData = new FormData();
    formData.append('site_slug', data.site_slug);
    formData.append('file', data.file);
    if (data.name) formData.append('name', data.name);
    if (data.alt_text) formData.append('alt_text', data.alt_text);
    
    // 💡 Convertir le booléen en '1' ou '0' pour Laravel
    formData.append('is_public', data.is_public ? '1' : '0');

    // 🔍 DEBUG : Vérifier le contenu
    console.log('=== FORM DATA CONTENU ===');
    for (let [key, value] of formData.entries()) {
        if (value instanceof File) {
            console.log(key, 'File:', value.name, value.size, value.type);
        } else {
            console.log(key, value);
        }
    }

    const response = await axios.post(`${MAIN_API_URL}/media/upload`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
},



  // 🔒 PROTÉGÉ - Token requis
  async update(token: string, id: string, data: MediaFormData): Promise<Media> {
    try {
      const response = await axios.put(`${MAIN_API_URL}/media/${id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la mise à jour du média", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async delete(token: string, id: string): Promise<void> {
    try {
      await axios.delete(`${MAIN_API_URL}/media/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error("Erreur lors de la suppression du média", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async deleteMany(token: string, ids: string[]): Promise<void> {
    try {
      await axios.post(`${MAIN_API_URL}/media/delete-multiple`, { ids }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error("Erreur lors de la suppression multiple", error);
      throw error;
    }
  },
};